<script setup>
  import {computed, useSlots} from "vue";

  import {Link as InertiaLink} from "@inertiajs/vue3";

  defineOptions({name: "ComponentLinkButton"});

  const slots = useSlots();

  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "#",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    iconButton: {
      type: Boolean,
      default: false,
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
  });

  const hasSlot = computed(() => !!slots.default);

  const hasLabel = computed(() => props.label && props.label.length > 0);
</script>

<template>
  <component
    :is="href && !isExternal ? InertiaLink : 'a'"
    v-bind="$attrs"
    :href="href"
    class="p4umc-btn"
    :disabled="disabled"
    :data-test="getTestId((href && !isExternal ? 'inertia-link' : 'link') + '-button')"
  >
    <div :class="{'flex items-center': hasSlot && hasLabel}">
      <template v-if="iconButton">
        <div :class="{'mr-2': hasLabel}">
          <slot />
        </div>

        <span v-if="hasLabel" class="font-medium uppercase">
          {{ label }}
        </span>
      </template>

      <template v-else>
        <span v-if="hasLabel" class="font-medium uppercase">
          {{ label }}
        </span>
        <slot />
      </template>
    </div>
  </component>
</template>
